import api, {ROUTES} from '../../index';
import IapiAuthDetails from '../../../shared/Interfaces/apiAuthDetails';
import {genRoute} from '../../../utils/apiRouteGenerator';

export const getCityList = (
  auth: IapiAuthDetails,
  cb: (err: any, data: any[]) => void,
) => {
  api.get(`${genRoute(ROUTES.CITY, auth)}&provinceID=null`, cb);
};

export const getUserList = (
  auth: IapiAuthDetails,
  cb: (err: any, data: any[]) => void,
) => {
  api.get(genRoute(ROUTES.USER_LIST, auth), cb);
};

export const getRoleList = (
  auth: IapiAuthDetails,
  cb: (err: any, data: any[]) => void,
) => {
  api.get(genRoute(ROUTES.ROLE_LIST, auth), cb);
};

export const getLevelList = (
  roleID: any,
  auth: IapiAuthDetails,
  cb: (err: any, data: any[]) => void,
) => {
  api.get(`${genRoute(ROUTES.LEVEL_LIST, auth)}&roleID=${roleID}`, cb);
};

export const getOwnerList = (
  userTypeID: any,
  auth: IapiAuthDetails,
  cb: (err: any, data: any[]) => void,
) => {
  api.get(`${genRoute(ROUTES.OWNER_LIST, auth)}&userTypeID=${userTypeID}`, cb);
};

export const getUserTypeList = (
  auth: IapiAuthDetails,
  cb: (err: any, data: any[]) => void,
) => {
  api.get(genRoute(ROUTES.USER_TYPE_LIST, auth), cb);
};

export const getUserAccessToOtherAWBIDList = (
  auth: IapiAuthDetails,
  cb: (err: any, data: any[]) => void,
) => {
  api.get(genRoute(ROUTES.USER_USER_ACCESS, auth), cb);
};

export const userAddUpdate = (
  params: any,
  cb: (err: any, data: any) => void,
) => {
  api.post(ROUTES.USER_ADD_UPDATE, params, (err, data) => {
    cb(err, data);
  });
};

export const userDelete = (
  userID: any,
  auth: IapiAuthDetails,
  cb: (err: any, data: any[]) => void,
) => {
  api.delete(`${genRoute(ROUTES.USER_DELETE, auth)}&id=${userID}`, {}, cb);
};

export const getUserSelect = (
  userID: any,
  auth: IapiAuthDetails,
  cb: (err: any, data: any[]) => void,
) => {
  api.get(`${genRoute(ROUTES.USER_SELECT, auth)}&id=${userID}`, cb);
};

export const getUserCreditAmount = (
  auth: IapiAuthDetails,
  cb: (err: any, data: any[]) => void,
) => {
  api.get(genRoute(ROUTES.USER_CREDIT, auth), cb);
};
